export class Device {
    deviceId: string;
    deviceModel: string=null;
    deviceCategoryId: string=null;
    deviceCategoryName: string=null;
    deviceVersion: string;
    serialNumber: string;
    deviceMAC:string;
    manufacturer: string;
    fieldOfView: string;
    dataPath: string;
    accountId: any;
    orgId: any;
    orgName: any;
    status: boolean;
    created: string;
    lastUpdated: string;
    accountName: string;
}